<template>
  <div class="view pa24">
    <div>
      {{ $t('addedServices', 'selectStatus') }}：
      <el-radio
        class="mr10"
        style="margin: 0"
        v-for="(item, index) in radioArr"
        :key="index"
        v-model="radioValue"
        :label="item.value"
        border
        >{{ item.text }}</el-radio
      >
      <el-button type="primary" @click="search">{{ $t('addedServices', 'search') }}</el-button>
      <el-button
        type="primary"
        style="float: right"
        @click="$router.push({ path: '/demandPublishForm' })"
        >{{ $t('addedServices', 'publishDemand') }}</el-button
      >
    </div>
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
          type="index"
          align="center"
          :label="$t('addedServices', 'serialNumber')"
          show-overflow-tooltip
        />
        <el-table-column prop="createdTime" align="center" :label="$t('addedServices', 'createTime')" />
        <el-table-column prop="name" align="center" :label="$t('addedServices', 'publisher')" />
        <el-table-column prop="description" align="center" :label="$t('addedServices', 'content')" show-overflow-tooltip/>
        <el-table-column prop="images" align="center" :label="$t('addedServices', 'image')">
          <template slot-scope="scope">
            <el-image
              style="width: 36px; height: 36px"
              :src="scope.row.imagesList[0]"
              :preview-src-list="scope.row.imagesList"
            >
            </el-image>
            <span>x{{ scope.row.imagesList.length }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="note" align="center" :label="$t('addedServices', 'remark')" show-overflow-tooltip/>
        
        <el-table-column width="200px" show-overflow-tooltip prop="auditing" align="center" :label="$t('addedServices', 'status')">
          <template slot-scope="scope">
            {{
              scope.row.auditing == 0
                ? $t('addedServices', 'pendingReviewStatus')
                : scope.row.auditing == 1
                ? $t('addedServices', 'approved')
                : scope.row.auditing == 2
                ? $t('addedServices', 'rejectedReason') + scope.row.reasonNote + ")"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('addedServices', 'operation')">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="
                $router.push({
                  path: `/demandPublishForm?squareId=${scope.row.squareId}`,
                })
              "
              >{{ $t('addedServices', 'detail') }}</el-button
            >
            <!-- <customPopconfirm
              v-if="scope.row.auditing == '0'"
              confirm-button-text="确定"
              cancel-button-text="取消"
              @confirm="online(scope.row)"
              icon="el-icon-info"
              icon-color="red"
              :title="
                '确认' + (scope.row.status == '0' ? '上线' : '下线') + '吗？'
              ">
                <el-button class="ml10" slot="reference" type="text">
                  {{ scope.row.status == "1" ? "下线" : "上线" }}
                </el-button>
            </customPopconfirm> -->
            <customPopconfirm
              v-if="scope.row.auditing == '0'"
              :confirm-button-text="$t('addedServices', 'confirm')"
              :cancel-button-text="$t('addedServices', 'cancel')"
              @confirm="updateDemandSquareStatus(scope.row)"
              icon="el-icon-info"
              icon-color="red"
              :title="$t('addedServices', 'confirmWithdraw')">
                <el-button type="text" class="ml10" slot="reference">
                  {{ scope.row.auditing == "0" && $t('addedServices', 'withdraw') }}
                </el-button>
            </customPopconfirm>
            <customPopconfirm
              :confirm-button-text="$t('addedServices', 'confirm')"
              :cancel-button-text="$t('addedServices', 'cancel')"
              @confirm="deleteDemandSquare(scope.row)"
              icon="el-icon-info"
              icon-color="red"
              :title="$t('addedServices', 'confirmDelete')">
              <el-button
                class="ml10"
                slot="reference"
                type="text"
                style="color: #fd634e"
              >
                {{ $t('addedServices', 'delete') }}
              </el-button>
            </customPopconfirm>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import customPopconfirm from "@/components/common/customPopconfirm";
import i18nMixin from '@/mixins/i18nMixin';
import {
  queryPageMyDemandSquare,
  deleteDemandSquare,
  updateDemandSquareStatus,
} from "@/api/addedServices";
export default {
  mixins: [i18nMixin],
  data() {
    return {
      radioValue: "",
      radioArr: [
        { text: this.$t('addedServices', 'all'), value: "" },
        { text: this.$t('addedServices', 'pendingReview'), value: "0" },
        { text: this.$t('addedServices', 'rejected'), value: "2" },
        { text: this.$t('addedServices', 'published'), value: "1" },
      ],
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
    };
  },
  components: {
    commonTable,
    customPopconfirm
  },
  created() {
    this.queryPageMyDemandSquare();
  },
  methods: {
    /** */
    async queryPageMyDemandSquare() {
      let data = {
        pageSize: this.pageSize,
        isDraft: "0",
        auditing: this.radioValue,
      };
      try {
        this.loading = true;
        const result = await queryPageMyDemandSquare(data);
        this.loading = false;
        const {
          pageInfo: { total, list },
        } = result?.data;
        if (!list) {
          this.tableData = [];
          return;
        }
        list.forEach((item) => {
          item.imagesList = JSON.parse(item.images);
        });
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryPageMyDemandSquare();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryPageMyDemandSquare();
    },
    /**@method 搜索 */
    search() {
      this.queryPageMyDemandSquare();
    },
    /**@method 删除 */
    async deleteDemandSquare(row) {
      try {
        await deleteDemandSquare(row);
        this.queryPageMyDemandSquare();
      } catch (error) {
        console.log(error);
      }
    },
    /**@method 撤回 */
    async updateDemandSquareStatus(row) {
      try {
        row.isDraft = true;
        await updateDemandSquareStatus(row);
        this.queryPageMyDemandSquare();
      } catch (error) {
        console.log(error);
      }
    },
    /**@method 上线 */
    async online(row) {
      if (row.status == "0" && row.auditing != 1) {
        this.$message({
          message: this.$t('addedServices', 'auditPassedCanOnline'),
        });
        return;
      }
      row.status = row.status == "0" ? "1" : "0";
      row.isDraft = row.status == "0" ? true : false;
      try {
        await updateDemandSquareStatus(row);
        this.queryPageMyDemandSquare();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>